export default "__VITE_ASSET__D$LFxuGT__"